import { NoteDisplayLevel } from "src/app/web-api/web-api";

export class WawiApiNoteFacilityExtendedFilterModel {
    public eventFilter: NoteDisplayLevel;

    constructor(
        eventFilter?: NoteDisplayLevel,
    ) {
        this.eventFilter = eventFilter;
    }
}

